import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class GdprNotificationComponent extends Vue {
    showNotification: boolean = false;

    mounted() {
        if (!utils.Cookies.gdprGet() && G2S.config.theme === 'mego') {
            this.showNotification = true;
        }

        utils.PixelsService.setPixelForHomepage(document.getElementById('pixels')!);
    }

    onSubmit() {
        utils.Cookies.gdprSet();

        this.showNotification = false;
    }
}
